import { useState, useEffect } from "react";

function useLocalStorage(key, initialValue) {
  const [value, setValue] = useState(
    JSON.parse(localStorage.getItem(key) || null) || initialValue
  );

  useEffect(() => {
    // Save the value to localStorage whenever it changes
    localStorage.setItem(key, JSON.stringify(value || null));
  }, [key, value]);

  return [value, setValue];
}

export default useLocalStorage;
